import { useEffect, useState } from "react";
import client from "@/lib/api";

export function useProjects(params = {}) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params);
  useEffect(() => {
    let alive = true;
    setLoading(true);
    client
      .get("/projects", { params })
      .then(({ data }) => alive && setProjects(data))
      .catch(() => {})
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return { projects, loading };
}
